import { CLEAR_SITE_DATA } from '../application';
import { RECEIVE_ANALYTICS, SET_ANALYTICS_LOADING } from './actions';

const panelInitialState = {
  data: [],
  total: 0,
  isLoading: false,
};

const initialState = {
  panels: {},
};

const getPanelState = (state, panelId) => state.panels[panelId] || panelInitialState;

export function reducer(state = structuredClone(initialState), action) {
  switch (action.type) {
    case RECEIVE_ANALYTICS: {
      const { data, offset = 0, total = 0, panelId } = action;
      if (!panelId) return state;
      const panel = getPanelState(state, panelId);

      return {
        ...state,
        panels: {
          ...state.panels,
          [panelId]: {
            ...panel,
            data: offset > 0 ? [...panel.data, ...data] : data,
            total,
          },
        },
      };
    }

    case SET_ANALYTICS_LOADING: {
      const { panelId, loading } = action;
      if (!panelId) return state;
      const panel = getPanelState(state, panelId);

      return {
        ...state,
        panels: {
          ...state.panels,
          [panelId]: {
            ...panel,
            isLoading: loading,
          },
        },
      };
    }

    case CLEAR_SITE_DATA: {
      return structuredClone(initialState);
    }

    default: {
      return state;
    }
  }
}
